import { Select } from '@mantine/core';

import { STATUS_OPTIONS } from '../constants/status';
import { contentTypes } from '../types';

type Props = {
  value: contentTypes.Status | null;
  onChange: (value: contentTypes.Status | null) => void;
};

const FILTER_OPTIONS = [
  { value: '', label: 'Все статусы' },
  ...STATUS_OPTIONS.map((option) =>
    option.value === 'archived' ? { ...option, label: 'Archive' } : option
  ),
];

export const StatusFilter = ({ value, onChange }: Props) => {
  return (
    <Select
      value={value ?? ''}
      onChange={(next) => onChange((next as contentTypes.Status) || null)}
      data={FILTER_OPTIONS}
      allowDeselect={false}
      w={220}
      placeholder="Все статусы"
    />
  );
};
